var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import ContenedorIndice from './contenedor-indice';

function Contenedores(_ref) {
  var libroId = _ref.libroId,
      indexUnidad = _ref.indexUnidad,
      contenedores = _ref.contenedores,
      onEntrada = _ref.onEntrada;
  return React.createElement(React.Fragment, null, contenedores.map(function (contenedor, index) {
    return React.createElement(ContenedorIndice, _extends({
      key: 'contenedor-indice-' + libroId + '-' + index,
      indexUnidad: indexUnidad[libroId],
      libroId: libroId
    }, contenedor, {
      onEntrada: onEntrada
    }));
  }));
}

Contenedores.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.any,
  indexUnidad: t.any,
  contenedores: t.array,
  onEntrada: t.func
} : {};
export default Contenedores;